import React from 'react'
import { Box, Container, Typography, Button } from '@mui/material'
import { Home, ArrowBack } from '@mui/icons-material'
import { Link } from 'react-router-dom'

const NotFoundPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8, textAlign: 'center', minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: '4rem', md: '6rem' },
          fontWeight: 700,
          color: 'primary.main',
          mb: 2
        }}
      >
        404
      </Typography>

      <Typography
        variant="h4"
        sx={{
          color: 'primary.main',
          mb: 2,
          fontSize: { xs: '1.5rem', md: '2rem' }
        }}
      >
        Page Not Found
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: 'text.secondary',
          mb: 4,
          maxWidth: 400,
          mx: 'auto'
        }}
      >
        The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Button
          component={Link}
          to="/"
          variant="contained"
          color="primary"
          startIcon={<Home />}
          sx={{ borderRadius: 3, px: 3 }}
        >
          Go Home
        </Button>

        <Button
          onClick={() => window.history.back()}
          variant="outlined"
          color="primary"
          startIcon={<ArrowBack />}
          sx={{ borderRadius: 3, px: 3 }}
        >
          Go Back
        </Button>
      </Box>
    </Container>
  )
}

export default NotFoundPage